import { makeStyles } from '@material-ui/core/styles';

const styles = () => ({
  root: {
    backgroundColor: '#FFFBEE',
    border: '1px solid #F6BD17',
    borderRadius: 4,
    padding: '12px 16px',
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: 12,
    marginBottom: 16,
  },
  iconContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 48,
    height: 48,
    borderRadius: '50%',
    backgroundColor: '#F5E6A3',
    flexShrink: 0,
    '& svg': {
      fontSize: 24,
      color: '#B8860B',
    },
  },
  textSection: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: 4,
    flex: 1,
  },
  title: {
    fontSize: 16,
    fontWeight: 600,
    color: '#91461C',
    lineHeight: 'normal',
    whiteSpace: 'nowrap',
  },
  body: {
    fontSize: 14,
    color: '#91461C',
    lineHeight: 'normal',
    '& strong': {
      fontWeight: 500,
    },
  },
  buttonGroup: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    flexShrink: 0,
    '@media (max-width: 750px)': {
      flexDirection: 'column',
    },
  },
  dismissButton: {
    color: '#353535',
    fontSize: 14,
    fontWeight: 500,
    textTransform: 'uppercase',
    lineHeight: 1,
    letterSpacing: 0,
    textAlign: 'center',
    padding: '4px 8px',
    minWidth: 0,
    '&:hover': {
      backgroundColor: 'transparent',
      textDecoration: 'underline',
    },
  },
  actionButton: {
    backgroundColor: '#008EA9',
    color: '#ffffff',
    borderRadius: 4,
    padding: '4px 12px',
    fontSize: 14,
    fontWeight: 500,
    textTransform: 'uppercase',
    minWidth: 85,
    whiteSpace: 'nowrap',
    '&:hover': {
      backgroundColor: '#008EA9',
    },
  },
});

export default styles;
export const useStyles = makeStyles(styles);
